export default "__VITE_ASSET__QzSbG6G3__"